import React, { useEffect, useState, FunctionComponent } from 'react';

import { ListDropdown } from '@components/library/dropdown/index';
import { searchOptions } from '@components/show_page/sections/section_search/helper';
import { SearchOperatorOptions, SearchOption } from '@components/show_page/sections/section_search/SearchTypes';
import { update as updateBrandfolderResource } from '@api/v4/resources/resources';

interface DefaultSearchOptionProps {
  defaultStrictSearch: boolean;
  defaultSearchOperator: SearchOperatorOptions.OR | SearchOperatorOptions.AND;
}

const notifySuccess = (): void => Notify.create({
  title: t('Default Search Option setting updated!'),
  type: "success"
});

const notifyFailure = (): void => Notify.create({
  title: t('Error updating Default Search Option setting, please contact support'),
  type: "error"
});

const DefaultSearchOption: FunctionComponent<DefaultSearchOptionProps> = ({
  defaultStrictSearch,
  defaultSearchOperator,
}) => {
  const [selectedValue, setSelectedValue] = useState(SearchOperatorOptions.Strict);

  const handleChange = (value: SearchOperatorOptions): void => {
    setSelectedValue((prevState) => {
      if (prevState !== value) {
        updateBrandfolderResource({
          key: BFG.resource.key,
          ...(value === SearchOperatorOptions.Strict)
            ? { defaultStrictSearch: true }
            : { defaultSearchOperator: value },
        })
          .then(() => { notifySuccess(); })
          .catch(() => { notifyFailure(); });
      }
      return value;
    });
  };

  useEffect(() => {
    setSelectedValue(defaultStrictSearch ? SearchOperatorOptions.Strict : defaultSearchOperator);
  }, []);

  return (
    <div className="advanced-tab-settings__options">
      <ListDropdown
        onChange={(option: SearchOption): void => handleChange(option.value)}
        options={searchOptions().filter((option: SearchOption) => option.value !== SearchOperatorOptions.Quoted)}
        value={selectedValue}
      />
    </div>
  );
};

export default DefaultSearchOption;
